import { Constructor } from '@angular/cdk/table';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type WithLandingPageHeadlineFormSectionType = {
  _initLandingPageHeadline(landingPageHeadline: string): void;
  _initLandingPageHeadlineValueChanges(
    getPreviousLandingPageHeadline: () => string | null
  ): void;
  _buildLandingPageHeadline(): string;
};

type LandingPageHeadlineFormSectionRequirementsBase = {
  form: FormGroup;
  FORM_PATHS: { LANDING_PAGE_HEADLINE: () => string };
  destroy$: Subject<boolean>;
};

export function WithLandingPageHeadlineFormSection<
  TBase extends Constructor<LandingPageHeadlineFormSectionRequirementsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithLandingPageHeadlineFormSectionType;
  prototype: WithLandingPageHeadlineFormSectionType;
} & TBase {
  return class WithLandingPageHeadlineFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initLandingPageHeadline(landingPageHeadline: string): void {
      this.form
        .get(this.FORM_PATHS.LANDING_PAGE_HEADLINE())
        .setValue(landingPageHeadline);
    }

    _initLandingPageHeadlineValueChanges(
      getPreviousLandingPageHeadline: () => string | null
    ) {
      this.form
        .get(this.FORM_PATHS.LANDING_PAGE_HEADLINE())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousLandingPageHeadline()) {
              this.form
                .get(this.FORM_PATHS.LANDING_PAGE_HEADLINE())
                .markAsPristine();
            }
          },
        });
    }

    _buildLandingPageHeadline(): string {
      return this.form.get(this.FORM_PATHS.LANDING_PAGE_HEADLINE()).value;
    }
  };
}
